import { useState } from "react"
import { Checkbox, ListItem, ListItemLabel } from "@mezo-org/mezo-clay"

export default function SendFromAnotherWalletListItem() {
  // TODO: Temporary solution
  const [isChecked, setIsChecked] = useState(false)

  return (
    <ListItem
      endEnhancer={() => (
        <Checkbox
          checkmarkType="toggle"
          checked={isChecked}
          onChange={(event) => setIsChecked(event.target.checked)}
        />
      )}
      overrides={{
        Content: {
          style: { borderBottom: "none" },
        },
      }}
    >
      <ListItemLabel
        overrides={{
          LabelContent: {
            style: ({ $theme }) => ({
              color: $theme.colors.contentPrimary,
            }),
          },
        }}
      >
        Send from another wallet
      </ListItemLabel>
    </ListItem>
  )
}
